import _objectSpread from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { timeStampNow } from '@datadog/browser-core';
import { RecordType } from '../../types';
export function assembleIncrementalSnapshot(source, data) {
  return {
    data: _objectSpread({
      source: source
    }, data),
    type: RecordType.IncrementalSnapshot,
    timestamp: timeStampNow()
  };
}